import React from "react";
import "./loadingScreen.css";

const LoadingScreen = ({ message, userLoginStatus }) => {
  return (
      <div className="spinner-container">
          <svg className="gw-round-spinner entry-spinner" viewBox="25 25 50 50" style={{ width: '100px', height: '100px' }}>
          <circle cx="50" cy="50" r="20" />
        </svg>
          {message && (
              <div className="loading-message">
                  <p>{message}</p>
              </div>
          )}
      </div>
  
  );
};

export default LoadingScreen;
